import { Box, styled, Typography } from "@mui/material";
import WarningAmberIcon from "@mui/icons-material/WarningAmber";

export const MainContainer = styled(Box)({
  display: "flex",
  flexDirection: "column",
  gap: "16px",
  width: "100%",
});

export const ContentContainer = styled(Box)({
  display: "flex",
  flexDirection: "column",
  gap: "24px",
});

export const CodeWrapper = styled(Box)({
  display: "flex",
  flexDirection: "column",
  gap: "24px",
});

export const CodeTopContainer = styled(Box)({
  display: "flex",
  flexDirection: "column",
  gap: "24px",
});

export const CodeBottomContainer = styled(Box)({
  display: "flex",
  flexDirection: "column",
  gap: "16px",
});

export const SignStepTypography = styled(Typography)(({ theme }) => ({
  fontSize: "16px",
  fontWeight: 500,
  lineHeight: "23px",
  color: theme.palette.primary.main,
}));

export const CodeDescriptionText = styled(Typography)(({ theme }) => ({
  fontSize: "16px",
  fontWeight: 500,
  lineHeight: "24px",
  textAlign: "center",
  color: theme.palette.text.black,
}));

export const CodeContainer = styled("form")({
  display: "flex",
  flexDirection: "column",
  gap: "32px",
});

export const StyledErrorIcon = styled(WarningAmberIcon)(({ theme }) => ({
  fontSize: "24px",
  color: theme.palette.error.main,
  marginRight: "12px",
}));

export const IncorrectCodeText = styled(Typography)(({ theme }) => ({
  fontSize: "16px",
  fontWeight: 400,
  lineHeight: "24px",
  letterSpacing: "0.15px",
  color: theme.palette.error.main,
  textAlign: "center",
  marginTop: "-16px",
}));

export const ButtonContainer = styled(Box)({
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  gap: "8px",
});

export const NewLoginContactUsParagraph = styled(Typography)(({ theme }) => ({
  fontSize: "16px",
  fontWeight: 400,
  lineHeight: "23px",
  letterSpacing: "0.5px",
  textAlign: "center",
  color: theme.palette.text.black,
}));

export const NewLoginContactUsText = styled("span")(({ theme }) => ({
  fontSize: "16px",
  fontWeight: 500,
  lineHeight: "17px",
  letterSpacing: "0.4px",
  textDecoration: "underline",
  textAlign: "center",
  color: theme.palette.text.link,
  cursor: "pointer",
}));

export const MoreInfoLink = styled("span")(({ theme }) => ({
  color: theme.palette.text.link,
  textDecoration: "underline",
  cursor: "pointer",
}));
